export default __webpack_public_path__ + "static/media/3.fb24e504.PNG";